var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bigSchoolIntroduction-page" }, [
    _vm.screenType == 0
      ? _c("div", { staticClass: "cross" }, [
          _c("div", { staticClass: "swiper-containerFocus" }, [
            _c(
              "div",
              { staticClass: "swiper-wrapper" },
              _vm._l(_vm.swiperList, function (item, index) {
                return _c("div", { key: index, staticClass: "swiper-slide" }, [
                  _c("img", {
                    staticClass: "swiper-img",
                    attrs: {
                      src: require("../../../../assets/themes/img/teasLogin/bg.jpg"),
                    },
                  }),
                ])
              }),
              0
            ),
            _c("div", { staticClass: "swiper-pagination" }),
          ]),
        ])
      : _c("div", { staticClass: "vertical" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }